import React from 'react';
import PropTypes from 'prop-types';

import ControlSite from './ControlSite';
import ControlRootNode from './ControlRootNode';
import ControlDimensions from './ControlDimensions';

const Control = (props) => (
	<div>
		<ControlSite name={props.site.name} packageKey={props.site.packageKey} nodeName={props.site.nodeName} change={props.onSiteChange} />
		<ControlRootNode nodeType={props.rootNode.nodeType} title={props.rootNode.title} uriPathSegment={props.rootNode.uriPathSegment} change={props.onRootNodeChange} />
		<ControlDimensions dimensions={props.dimensions} change={props.onDimensionChange} />
	</div>
);

Control.propTypes = {
	site: PropTypes.object.isRequired,
	rootNode: PropTypes.object.isRequired,
	dimensions: PropTypes.object.isRequired,
	onSiteChange: PropTypes.func.isRequired,
	onRootNodeChange: PropTypes.func.isRequired,
	onDimensionChange: PropTypes.func.isRequired
};

export default Control;



// WEBPACK FOOTER //
// ./src/components/SiteGenerator/Control.js